import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "editor", "form", "cancelButton"]

  connect() {
    // Initially show display and hide editor
    this.showDisplay()
    
    // When a Trix editor form submission succeeds, we need to handle redirects
    // since we're using a form submission to save the content
    document.addEventListener("turbo:submit-end", (event) => {
      if (event.detail.success && this.formTarget === event.detail.formSubmission.formElement) {
        // If the submission was successful and it was our form, show the display view
        // This is a fallback in case the page doesn't reload
        this.showDisplay()
      }
    })
  }

  startEditing() {
    this.displayTarget.classList.add("hidden")
    this.editorTarget.classList.remove("hidden")
    
    // Focus the trix editor when it becomes visible
    const trixEditor = this.editorTarget.querySelector("trix-editor")
    if (trixEditor) {
      setTimeout(() => {
        trixEditor.focus()
      }, 100)
    }
  }

  cancelEditing(event) {
    if (event) event.preventDefault()
    this.showDisplay()
  }

  showDisplay() {
    this.displayTarget.classList.remove("hidden")
    this.editorTarget.classList.add("hidden")
  }

  // Handle escape key to cancel editing
  handleKeydown(event) {
    if (event.key === "Escape") {
      this.cancelEditing()
    }
  }
} 
